/* Piccoli — comportamientos de UI portados del prototipo.
   Todo lo que aquí NO está lo resuelve Shopify: enrutado, carrito,
   checkout, filtros de colección y selección de variante. */
(function () {
  'use strict';

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- textos traducibles ---------- */
  // El layout los deja en window.piccoliTextos con el filtro t de Shopify.
  // Si no están, queda el texto en español que se pasa como respaldo.
  function texto(clave, respaldo) {
    const valor = window.piccoliTextos && window.piccoliTextos[clave];
    if (typeof valor !== 'string' || !valor) return respaldo;
    // t devuelve el texto escapado (' llega como &#39;): se decodifica para textContent
    const area = document.createElement('textarea');
    area.innerHTML = valor;
    return area.value;
  }

  /* ---------- hero slider ---------- */
  let slideIdx = 0, slideTimer = null;

  function showSlide(n) {
    const slides = $$('.hero-slide'), dots = $$('.hero-dot');
    if (!slides.length) return;
    slideIdx = (n + slides.length) % slides.length;
    slides.forEach((s, i) => {
      const on = i === slideIdx;
      s.classList.toggle('is-active', on);
      if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      $$('a', s).forEach(a => a.tabIndex = on ? 0 : -1);
    });
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === slideIdx);
      d.setAttribute('aria-selected', String(i === slideIdx));
    });
  }

  function autoplay(on) {
    clearInterval(slideTimer);
    const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (on && !quieto && $$('.hero-slide').length > 1) {
      slideTimer = setInterval(() => showSlide(slideIdx + 1), 6500);
    }
  }

  function initSlider() {
    const hero = $('.hero');
    if (!hero) { clearInterval(slideTimer); return; }
    showSlide(0);
    hero.addEventListener('mouseenter', () => autoplay(false));
    hero.addEventListener('mouseleave', () => autoplay(true));
    hero.addEventListener('focusin', () => autoplay(false));
    hero.addEventListener('focusout', () => autoplay(true));
    autoplay(true);
  }


  /* ---------- autoavance del carrusel de productos ---------- */
  let carruselTimer = null;

  function carruselAuto(on) {
    clearInterval(carruselTimer);
    const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const track = $('#p-track');
    if (!on || quieto || !track) return;
    carruselTimer = setInterval(() => {
      const card = track.querySelector('.p-card');
      if (!card) return;
      // al llegar al final vuelve al inicio en vez de quedarse clavado
      const fin = track.scrollWidth - track.clientWidth - 4;
      if (track.scrollLeft >= fin) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: card.offsetWidth + 22, behavior: 'smooth' });
    }, 1000);
  }

  function initCarrusel() {
    const track = $('#p-track');
    if (!track) { clearInterval(carruselTimer); return; }
    // se detiene mientras el usuario mira o interactúa
    track.addEventListener('mouseenter', () => carruselAuto(false));
    track.addEventListener('mouseleave', () => carruselAuto(true));
    track.addEventListener('focusin', () => carruselAuto(false));
    track.addEventListener('focusout', () => carruselAuto(true));
    carruselAuto(true);
  }

  /* ---------- age gate ---------- */
  let gateVolverA = null;

  function closeGate() {
    const g = $('#gate');
    if (!g) return;
    g.hidden = true;
    document.body.classList.remove('no-scroll');
    try { sessionStorage.setItem('piccoli-age', 'ok'); } catch (e) {}
    if (gateVolverA && gateVolverA.focus) gateVolverA.focus();
    autoplay(true);
  }

  function initGate() {
    const g = $('#gate');
    if (!g) return;
    // dentro del editor de temas el aviso solo estorba
    if (window.Shopify && window.Shopify.designMode) { g.hidden = true; return; }
    let visto = false;
    try { visto = sessionStorage.getItem('piccoli-age') === 'ok'; } catch (e) {}
    if (visto) { g.hidden = true; return; }
    gateVolverA = document.activeElement;
    g.hidden = false;
    document.body.classList.add('no-scroll');
    autoplay(false);
    const foco = $('[data-gate-close]', g);
    if (foco) foco.focus();
    // el foco no puede salir del diálogo mientras esté abierto
    g.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const f = $$('button,[href]', g);
      if (!f.length) return;
      const primero = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    });
  }

  /* ---------- eventos delegados ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-hero],[data-hero-dot],[data-pslide],[data-goshot],#burger,[data-gate-close]');
    if (!t) return;

    if (t.hasAttribute('data-hero')) { showSlide(slideIdx + (+t.dataset.hero)); autoplay(true); return; }
    if (t.hasAttribute('data-hero-dot')) { showSlide(+t.dataset.heroDot); autoplay(true); return; }

    if (t.hasAttribute('data-pslide')) {
      const track = $('#p-track');
      const card = track && track.querySelector('.p-card');
      if (card) track.scrollBy({ left: (card.offsetWidth + 22) * (+t.dataset.pslide), behavior: 'smooth' });
      carruselAuto(true);
      return;
    }

    if (t.hasAttribute('data-goshot')) {
      const s = document.getElementById('shot-' + t.dataset.goshot);
      if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (t.id === 'burger') {
      const menu = $('#mobile-menu');
      if (!menu) return;
      const abierto = menu.classList.toggle('open');
      t.setAttribute('aria-expanded', String(abierto));
      return;
    }

    if (t.hasAttribute('data-gate-close')) { closeGate(); return; }
  });


  /* ---------- ficha de producto ---------- */
  function initProducto() {
    const form = document.getElementById('form-producto');
    if (!form) return;

    // el stepper solo mueve el input: la cantidad la envía el propio form
    form.addEventListener('click', e => {
      const b = e.target.closest('[data-qty]');
      if (!b) return;
      const input = form.querySelector('.qty-input');
      if (!input) return;
      const n = Math.max(1, (parseInt(input.value, 10) || 1) + (+b.dataset.qty));
      input.value = n;
    });

    form.addEventListener('change', e => {
      const r = e.target.closest('.variante-radio');
      if (!r) return;
      const precio = document.querySelector('[data-precio]');
      const sku = document.querySelector('[data-sku]');
      if (precio && r.dataset.precio) precio.textContent = r.dataset.precio;
      if (sku && r.dataset.sku) sku.textContent = r.dataset.sku;
    });
  }

  /* ---------- agregar al carrito sin salir de la página ---------- */
  // Como en el prototipo: aviso abajo a la derecha y contador actualizado.
  // Sin JS, o si falla la red, el form se envía normal y lleva al carrito.
  let toastTimer = null;

  function toast(msg) {
    const el = $('#toast');
    if (!el) return;
    $('#toast-text').textContent = msg;
    el.hidden = false;
    const live = $('#live-region');
    if (live) live.textContent = msg;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2800);
  }

  const raiz = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    e.preventDefault();
    const boton = form.querySelector('[type="submit"]');
    if (boton) boton.disabled = true;
    try {
      const r = await fetch(raiz() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || texto('errorAgregar', 'No se pudo agregar al carrito')); return; }
      const carrito = await (await fetch(raiz() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      $$('[data-cart-count]').forEach(n => { n.textContent = carrito.item_count; });
      const bloque = form.closest('.p-card, .pdp-panel, .product-cta');
      const titulo = bloque && bloque.querySelector('h1, h3');
      const nombre = titulo ? titulo.textContent.trim() : data.product_title;
      toast(texto('productoAgregado', '[producto] agregado').replace('[producto]', () => nombre));
    } catch (err) {
      form.submit();
    } finally {
      if (boton) boton.disabled = false;
    }
  });

  /* ---------- carrito: casilla +18 y botón de pago ---------- */
  function initCarrito() {
    const edad = $('[data-age]');
    const pagar = $('[data-checkout]');
    if (!edad || !pagar) return;
    const sync = () => {
      const ok = edad.checked;
      edad.closest('.age-check').classList.toggle('ok', ok);
      pagar.disabled = !(ok && +pagar.dataset.faltan <= 0);
    };
    edad.addEventListener('change', sync);
    sync();
  }

  /* ---------- carrito: boleta o factura ---------- */
  // Los datos van como atributos del carrito (ver piccoli-carrito.liquid).
  // Solo queda activo el grupo del comprobante elegido: el otro se oculta y se
  // deshabilita, así el navegador no lo valida ni lo envía al ir a pagar.
  function initComprobante() {
    const caja = $('[data-comprobante]');
    if (!caja) return;
    const form = caja.closest('form');
    const radios = $$('input[type="radio"]', caja);
    const campos = $$('[data-grupo] input', caja);
    const elegido = () => (radios.find(r => r.checked) || radios[0]).value;

    const sync = () => {
      const tipo = elegido();
      $$('[data-grupo]', caja).forEach(g => {
        const activo = g.dataset.grupo === tipo;
        g.hidden = !activo;
        $$('input', g).forEach(i => {
          i.disabled = !activo;
          if (i.hasAttribute('data-requerido')) i.required = activo;
        });
      });
    };

    // – / + y "Quitar" recargan la página: lo escrito se guarda en el carrito y
    // el Liquid lo vuelve a poner desde cart.attributes. Un guardado a la vez y
    // siempre con los valores del momento; keepalive para que no se corte al salir.
    let espera = null, enCurso = null, repetir = false;
    const guardar = () => {
      clearTimeout(espera);
      espera = null;
      if (enCurso) { repetir = true; return enCurso; }
      const attributes = { Comprobante: elegido() };
      campos.forEach(i => {
        const nombre = i.name.replace(/^attributes\[(.*)\]$/, '$1');
        // lo escrito para el otro comprobante se vacía, para que el pedido no lo lleve
        if (!i.disabled) attributes[nombre] = i.value;
        else if (i.value) attributes[nombre] = '';
      });
      enCurso = fetch(raiz() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
        keepalive: true
      }).catch(() => {}).then(() => {
        enCurso = null;
        if (repetir) { repetir = false; return guardar(); }
      });
      return enCurso;
    };
    const programar = () => { clearTimeout(espera); espera = setTimeout(guardar, 500); };

    caja.addEventListener('change', e => { if (e.target.type === 'radio') sync(); programar(); });
    caja.addEventListener('input', programar);

    if (form) {
      // con un guardado pendiente, el enlace espera a que termine (máximo 2 s)
      form.addEventListener('click', e => {
        const enlace = e.target.closest('.qty a, .cart-remove');
        if (!enlace || (!espera && !enCurso) || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const tope = new Promise(r => setTimeout(r, 2000));
        Promise.race([espera ? guardar() : enCurso, tope]).then(() => { location.href = enlace.href; });
      });
      // el form ya lleva lo escrito; esto solo vacía a tiempo el grupo que se dejó
      form.addEventListener('submit', () => { if (espera) guardar(); });
    }

    sync();
  }

  document.addEventListener('DOMContentLoaded', () => { initSlider(); initGate(); initProducto(); initCarrusel(); initCarrito(); initComprobante(); });

  // En el editor de temas, Shopify reemplaza el HTML de la sección editada sin
  // recargar la página: solo se reengancha lo que venía en esa sección, para
  // no duplicar listeners en las demás.
  document.addEventListener('shopify:section:load', e => {
    const s = e.target;
    if ($('.hero', s)) initSlider();
    if ($('#p-track', s)) initCarrusel();
    if ($('#form-producto', s)) initProducto();
    if ($('#form-carrito', s)) { initCarrito(); initComprobante(); }
  });
})();
